var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "csa-new flex-container" },
    [
      !_vm.dataloaded
        ? _c("eas-loader")
        : _c("div", { staticClass: "csabody flex-col flex-1" }, [
            _c("div", { staticClass: "flex-row flex-5 mb-1" }, [
              _c(
                "div",
                { class: ["flex-col", _vm.isPopup ? "flex-3" : "flex-4"] },
                [
                  _c("dl", [
                    _c("dt", [
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.csaLabels.commercialOutlookLabel) + ":"
                        ),
                      ]),
                    ]),
                    _c("dd", [
                      _c("br"),
                      _c("div", { staticClass: "flex-row flex-1" }, [
                        _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.csaLabels.commercialOutlookSubLabel1) +
                                ": "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "flex-col flex-4" }, [
                          _vm.isInEditMode
                            ? _c("div", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.csaData.commercialOutlookSubValue1,
                                      expression:
                                        "csaData.commercialOutlookSubValue1",
                                    },
                                  ],
                                  staticClass: "medium-input",
                                  attrs: { maxlength: "250" },
                                  domProps: {
                                    value:
                                      _vm.csaData.commercialOutlookSubValue1,
                                  },
                                  on: {
                                    keyup: function ($event) {
                                      return _vm.updateComponentInRealTime()
                                    },
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.csaData,
                                        "commercialOutlookSubValue1",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ])
                            : _c("div", [
                                _vm._v(
                                  _vm._s(_vm.csaData.commercialOutlookSubValue1)
                                ),
                              ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "flex-row flex-1" }, [
                        _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.csaLabels.commercialOutlookSubLabel2) +
                                ": "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "flex-col flex-4" }, [
                          _vm.isInEditMode
                            ? _c("div", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.csaData.commercialOutlookSubValue2,
                                      expression:
                                        "csaData.commercialOutlookSubValue2",
                                    },
                                  ],
                                  staticClass: "medium-input",
                                  attrs: { maxlength: "250" },
                                  domProps: {
                                    value:
                                      _vm.csaData.commercialOutlookSubValue2,
                                  },
                                  on: {
                                    keyup: function ($event) {
                                      return _vm.updateComponentInRealTime()
                                    },
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.csaData,
                                        "commercialOutlookSubValue2",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ])
                            : _c("div", [
                                _vm._v(
                                  _vm._s(_vm.csaData.commercialOutlookSubValue2)
                                ),
                              ]),
                        ]),
                      ]),
                    ]),
                    _c("dt", [
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.csaLabels.currentValueDriverLabel) + ":"
                        ),
                      ]),
                    ]),
                    _c("dd", [
                      _c("br"),
                      _vm.isInEditMode
                        ? _c("div", { staticClass: "pre-formatted" }, [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.csaData.currentValueDriver,
                                  expression: "csaData.currentValueDriver",
                                },
                              ],
                              attrs: { maxlength: "500" },
                              domProps: {
                                value: _vm.csaData.currentValueDriver,
                              },
                              on: {
                                keyup: function ($event) {
                                  return _vm.updateComponentInRealTime()
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.csaData,
                                    "currentValueDriver",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ])
                        : _c("div", { staticClass: "pre-formatted" }, [
                            _vm._v(_vm._s(_vm.csaData.currentValueDriver)),
                          ]),
                    ]),
                    _c("dt", [
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.csaLabels.ltContractValueLabel) + ":"
                        ),
                      ]),
                    ]),
                    _c("dd", [
                      _c("br"),
                      _vm.isInEditMode
                        ? _c("div", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.csaData.ltContractValue,
                                  expression: "csaData.ltContractValue",
                                },
                              ],
                              attrs: { maxlength: "250" },
                              domProps: { value: _vm.csaData.ltContractValue },
                              on: {
                                keyup: function ($event) {
                                  return _vm.updateComponentInRealTime()
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.csaData,
                                    "ltContractValue",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ])
                        : _c("div", [
                            _vm._v(_vm._s(_vm.csaData.ltContractValue)),
                          ]),
                    ]),
                    _c("dt", [
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.csaLabels.runningRegimeTrendLabel) + ":"
                        ),
                      ]),
                    ]),
                    _c("dd", [
                      _c("br"),
                      _vm.isInEditMode
                        ? _c("div", [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.csaData.runningRegime,
                                  expression: "csaData.runningRegime",
                                },
                              ],
                              staticClass: "mb-2",
                              attrs: { maxlength: "250" },
                              domProps: { value: _vm.csaData.runningRegime },
                              on: {
                                keyup: function ($event) {
                                  return _vm.updateComponentInRealTime()
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.csaData,
                                    "runningRegime",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.csaData.runningTrend,
                                    expression: "csaData.runningTrend",
                                  },
                                ],
                                attrs: { name: "rtrend" },
                                on: {
                                  click: function ($event) {
                                    return _vm.updateComponentInRealTime()
                                  },
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.csaData,
                                      "runningTrend",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              [
                                _c("option", { attrs: { value: "Up" } }, [
                                  _vm._v(_vm._s(_vm.$t("up"))),
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "Unchanged" } },
                                  [_vm._v(_vm._s(_vm.$t("unchanged")))]
                                ),
                                _c("option", { attrs: { value: "Down" } }, [
                                  _vm._v(_vm._s(_vm.$t("down"))),
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "No running forecasted" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("noRunningForecasted"))
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        : _c("div", [
                            _c("div", { staticClass: "mb-1" }, [
                              _vm._v(_vm._s(_vm.csaData.runningRegime)),
                            ]),
                            _vm.csaData.runningTrend == "Unchanged"
                              ? _c(
                                  "div",
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fas", "arrow-right"] },
                                    }),
                                  ],
                                  1
                                )
                              : _vm.csaData.runningTrend == "Up"
                              ? _c(
                                  "div",
                                  { staticClass: "uparrow" },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fas", "arrow-up"] },
                                    }),
                                  ],
                                  1
                                )
                              : _vm.csaData.runningTrend == "Down"
                              ? _c(
                                  "div",
                                  { staticClass: "downarrow" },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fas", "arrow-down"] },
                                    }),
                                  ],
                                  1
                                )
                              : _vm.csaData.runningTrend ==
                                "No running forecasted"
                              ? _c("div", [
                                  _vm._v(_vm._s(_vm.$t("noRunningForecasted"))),
                                ])
                              : _vm._e(),
                          ]),
                    ]),
                    _c("dt", [
                      _c("b", [
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.csaLabels.co2AbatementCostsLabel.replace(
                                "CO2",
                                "CO<sub>2</sub>"
                              ) + ":"
                            ),
                          },
                        }),
                      ]),
                    ]),
                    _c("dd", [
                      _vm.isInEditMode
                        ? _c("div", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.csaData.co2AbatementCostsText1,
                                  expression: "csaData.co2AbatementCostsText1",
                                },
                              ],
                              staticClass: "small-input",
                              attrs: { maxlength: "250" },
                              domProps: {
                                value: _vm.csaData.co2AbatementCostsText1,
                              },
                              on: {
                                keyup: function ($event) {
                                  return _vm.updateComponentInRealTime()
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.csaData,
                                    "co2AbatementCostsText1",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" : "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.csaData.co2AbatementCostsValue1,
                                  expression: "csaData.co2AbatementCostsValue1",
                                },
                              ],
                              staticClass: "small-input",
                              attrs: { maxlength: "200" },
                              domProps: {
                                value: _vm.csaData.co2AbatementCostsValue1,
                              },
                              on: {
                                keyup: function ($event) {
                                  return _vm.updateComponentInRealTime()
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.csaData,
                                    "co2AbatementCostsValue1",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("br"),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.csaData.co2AbatementCostsText2,
                                  expression: "csaData.co2AbatementCostsText2",
                                },
                              ],
                              staticClass: "small-input",
                              attrs: { maxlength: "250" },
                              domProps: {
                                value: _vm.csaData.co2AbatementCostsText2,
                              },
                              on: {
                                keyup: function ($event) {
                                  return _vm.updateComponentInRealTime()
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.csaData,
                                    "co2AbatementCostsText2",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" : "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.csaData.co2AbatementCostsValue2,
                                  expression: "csaData.co2AbatementCostsValue2",
                                },
                              ],
                              staticClass: "small-input",
                              attrs: { maxlength: "200" },
                              domProps: {
                                value: _vm.csaData.co2AbatementCostsValue2,
                              },
                              on: {
                                keyup: function ($event) {
                                  return _vm.updateComponentInRealTime()
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.csaData,
                                    "co2AbatementCostsValue2",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ])
                        : _c("div", [
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.csaData.co2AbatementCostsText1) +
                                  " : " +
                                  _vm._s(_vm.csaData.co2AbatementCostsValue1)
                              ),
                            ]),
                            _c("br"),
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.csaData.co2AbatementCostsText2) +
                                  " : " +
                                  _vm._s(_vm.csaData.co2AbatementCostsValue2)
                              ),
                            ]),
                          ]),
                      _c("br"),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.csaLabels.specificEmissionsLabel) + ":"
                        ),
                      ]),
                      _c("br"),
                      _vm._v(
                        " " + _vm._s(_vm.csaData.specificEmissionsText) + " "
                      ),
                      _c("br"),
                      _vm.isInEditMode
                        ? _c("div", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.csaData.specificEmissionsValue,
                                  expression: "csaData.specificEmissionsValue",
                                },
                              ],
                              staticClass: "small-input",
                              attrs: { maxlength: "50", type: "number" },
                              domProps: {
                                value: _vm.csaData.specificEmissionsValue,
                              },
                              on: {
                                keyup: function ($event) {
                                  return _vm.updateComponentInRealTime()
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.csaData,
                                    "specificEmissionsValue",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(
                              "  " +
                                _vm._s(
                                  _vm.csaLabels
                                    .specificEmissionsMeasureUnitLabel
                                ) +
                                " "
                            ),
                          ])
                        : _vm.csaData.specificEmissionsValue > 0
                        ? _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.csaData.specificEmissionsValue) +
                                " " +
                                _vm._s(
                                  _vm.csaLabels
                                    .specificEmissionsMeasureUnitLabel
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    !_vm.isPopup
                      ? _c("div", [
                          _c("dt", [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.csaLabels.commentSustainabilityLabel
                                ) + ":"
                              ),
                            ]),
                          ]),
                          _c("dd", [
                            _c("br"),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.co2subscript(
                                    _vm.csaData.commentSustainabilityValue
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("dt", [
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.csaLabels.externalRisksLabel) + ":"
                              ),
                            ]),
                          ]),
                          _c("dd", [
                            _c("br"),
                            _vm._v(
                              " " + _vm._s(_vm.csaData.externalRisksValue) + " "
                            ),
                          ]),
                          _c("dt", [
                            _c("b", [
                              _vm._v(_vm._s(_vm.csaLabels.pmaViewLabel) + ":"),
                            ]),
                          ]),
                          _c("dd", [
                            _c("br"),
                            _vm._v(
                              " " + _vm._s(_vm.csaData.pmaViewValue) + " "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm.isPopup
                ? _c("div", { staticClass: "flex-col flex-3" }, [
                    _c("dl", [
                      _c("dt", [
                        _c("b", [
                          _vm._v(
                            _vm._s(_vm.csaLabels.commentSustainabilityLabel) +
                              ":"
                          ),
                        ]),
                      ]),
                      _c("dd", [
                        _c("br"),
                        _vm.isInEditMode
                          ? _c("div", [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.csaData.commentSustainabilityValue,
                                    expression:
                                      "csaData.commentSustainabilityValue",
                                  },
                                ],
                                attrs: { maxlength: "1000" },
                                domProps: {
                                  value: _vm.csaData.commentSustainabilityValue,
                                },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateComponentInRealTime()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.csaData,
                                      "commentSustainabilityValue",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ])
                          : _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.co2subscript(
                                    _vm.csaData.commentSustainabilityValue
                                  )
                                )
                              ),
                            ]),
                      ]),
                      _c("dt", [
                        _c("b", [
                          _vm._v(
                            _vm._s(_vm.csaLabels.externalRisksLabel) + ":"
                          ),
                        ]),
                      ]),
                      _c("dd", [
                        _c("br"),
                        _vm.isInEditMode
                          ? _c("div", [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.csaData.externalRisksValue,
                                    expression: "csaData.externalRisksValue",
                                  },
                                ],
                                attrs: { maxlength: "500" },
                                domProps: {
                                  value: _vm.csaData.externalRisksValue,
                                },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateComponentInRealTime()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.csaData,
                                      "externalRisksValue",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ])
                          : _c("div", [
                              _vm._v(_vm._s(_vm.csaData.externalRisksValue)),
                            ]),
                      ]),
                      _c("dt", [
                        _c("b", [
                          _vm._v(_vm._s(_vm.csaLabels.pmaViewLabel) + ":"),
                        ]),
                      ]),
                      _c("dd", [
                        _c("br"),
                        _vm.isInEditMode
                          ? _c("div", [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.csaData.pmaViewValue,
                                    expression: "csaData.pmaViewValue",
                                  },
                                ],
                                attrs: { maxlength: "1000" },
                                domProps: { value: _vm.csaData.pmaViewValue },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateComponentInRealTime()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.csaData,
                                      "pmaViewValue",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ])
                          : _c("div", [
                              _vm._v(_vm._s(_vm.csaData.pmaViewValue)),
                            ]),
                      ]),
                      _vm.isInEditMode
                        ? _c("div", [
                            _c("dt", [
                              _c("b", [
                                _vm._v(_vm._s(_vm.$t("comment")) + ":"),
                              ]),
                            ]),
                            _c("dd", [
                              _c("br"),
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.updComment,
                                    expression: "updComment",
                                  },
                                ],
                                class: { invalid: _vm.isCommentEmpty },
                                attrs: { maxlength: "250" },
                                domProps: { value: _vm.updComment },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateComponentInRealTime()
                                  },
                                  focus: () => (_vm.isCommentEmpty = false),
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.updComment = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "flex-col flex-4" }, [
                _c("div", { staticClass: "flex-row" }, [
                  _c(
                    "div",
                    {
                      class: {
                        "flex-col": true,
                        "flex-1": true,
                        border: _vm.isInEditMode,
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex-row chart-title chart-title-fcf" },
                        [_vm._v(_vm._s(_vm.$t("freeCashFlow")))]
                      ),
                      _c("div", { staticClass: "flex-row" }, [
                        _c("div", {
                          staticClass: "fcf-chart",
                          attrs: { id: _vm.fcfChartId },
                        }),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex-row flex-1 flex-justify-center mb-2",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex-col flex-align-end text-no-wrap pl-5",
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "legend-p5-p95" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fas", "square"] },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "flex-col" }, [
                            _vm._v("P5 - P95"),
                          ]),
                        ]
                      ),
                      _vm.isInEditMode
                        ? _c("div", { staticClass: "flex-row grey-bg" }, [
                            _c("div", {
                              staticClass:
                                "flex-col flex-1 flex-justify-center",
                            }),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _vm._v(_vm._s(_vm.csaData.yearLabels[0])),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _vm._v(_vm._s(_vm.csaData.yearLabels[1])),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _vm._v(_vm._s(_vm.csaData.yearLabels[2])),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _vm._v(_vm._s(_vm.csaData.yearLabels[3])),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _vm._v(_vm._s(_vm.csaData.yearLabels[4])),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.isInEditMode
                        ? _c("div", { staticClass: "flex-row grey-bg" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex-col flex-1 flex-justify-center",
                              },
                              [_vm._v("FCF")]
                            ),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.csaData.fcfValues[0],
                                    expression: "csaData.fcfValues[0]",
                                    modifiers: { number: true },
                                  },
                                ],
                                staticClass: "extra-small-input",
                                attrs: { maxlength: "11", type: "number" },
                                domProps: { value: _vm.csaData.fcfValues[0] },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateCharttInRealTime()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.csaData.fcfValues,
                                      0,
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.csaData.fcfValues[1],
                                    expression: "csaData.fcfValues[1]",
                                    modifiers: { number: true },
                                  },
                                ],
                                staticClass: "extra-small-input",
                                attrs: { maxlength: "11", type: "number" },
                                domProps: { value: _vm.csaData.fcfValues[1] },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateCharttInRealTime()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.csaData.fcfValues,
                                      1,
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.csaData.fcfValues[2],
                                    expression: "csaData.fcfValues[2]",
                                    modifiers: { number: true },
                                  },
                                ],
                                staticClass: "extra-small-input",
                                attrs: { maxlength: "11", type: "number" },
                                domProps: { value: _vm.csaData.fcfValues[2] },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateCharttInRealTime()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.csaData.fcfValues,
                                      2,
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.csaData.fcfValues[3],
                                    expression: "csaData.fcfValues[3]",
                                    modifiers: { number: true },
                                  },
                                ],
                                staticClass: "extra-small-input",
                                attrs: { maxlength: "11", type: "number" },
                                domProps: { value: _vm.csaData.fcfValues[3] },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateCharttInRealTime()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.csaData.fcfValues,
                                      3,
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.csaData.fcfValues[4],
                                    expression: "csaData.fcfValues[4]",
                                    modifiers: { number: true },
                                  },
                                ],
                                staticClass: "extra-small-input",
                                attrs: { maxlength: "11", type: "number" },
                                domProps: { value: _vm.csaData.fcfValues[4] },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateCharttInRealTime()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.csaData.fcfValues,
                                      4,
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.isInEditMode
                        ? _c("div", { staticClass: "flex-row grey-bg" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex-col flex-1 flex-justify-center",
                              },
                              [_vm._v("P5")]
                            ),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.csaData.p5Values[0],
                                    expression: "csaData.p5Values[0]",
                                    modifiers: { number: true },
                                  },
                                ],
                                staticClass: "extra-small-input",
                                attrs: { maxlength: "11", type: "number" },
                                domProps: { value: _vm.csaData.p5Values[0] },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateCharttInRealTime()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.csaData.p5Values,
                                      0,
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.csaData.p5Values[1],
                                    expression: "csaData.p5Values[1]",
                                    modifiers: { number: true },
                                  },
                                ],
                                staticClass: "extra-small-input",
                                attrs: { maxlength: "11", type: "number" },
                                domProps: { value: _vm.csaData.p5Values[1] },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateCharttInRealTime()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.csaData.p5Values,
                                      1,
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.csaData.p5Values[2],
                                    expression: "csaData.p5Values[2]",
                                    modifiers: { number: true },
                                  },
                                ],
                                staticClass: "extra-small-input",
                                attrs: { maxlength: "11", type: "number" },
                                domProps: { value: _vm.csaData.p5Values[2] },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateCharttInRealTime()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.csaData.p5Values,
                                      2,
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _c("input", {
                                staticClass: "extra-small-input",
                                attrs: { readonly: "" },
                                domProps: { value: _vm.$t("na") },
                              }),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _c("input", {
                                staticClass: "extra-small-input",
                                attrs: { readonly: "" },
                                domProps: { value: _vm.$t("na") },
                              }),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.isInEditMode
                        ? _c("div", { staticClass: "flex-row grey-bg" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex-col flex-1 flex-justify-center",
                              },
                              [_vm._v("P95")]
                            ),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.csaData.p95Values[0],
                                    expression: "csaData.p95Values[0]",
                                    modifiers: { number: true },
                                  },
                                ],
                                staticClass: "extra-small-input",
                                attrs: { maxlength: "11", type: "number" },
                                domProps: { value: _vm.csaData.p95Values[0] },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateCharttInRealTime()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.csaData.p95Values,
                                      0,
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.csaData.p95Values[1],
                                    expression: "csaData.p95Values[1]",
                                    modifiers: { number: true },
                                  },
                                ],
                                staticClass: "extra-small-input",
                                attrs: { maxlength: "11", type: "number" },
                                domProps: { value: _vm.csaData.p95Values[1] },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateCharttInRealTime()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.csaData.p95Values,
                                      1,
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.csaData.p95Values[2],
                                    expression: "csaData.p95Values[2]",
                                    modifiers: { number: true },
                                  },
                                ],
                                staticClass: "extra-small-input",
                                attrs: { maxlength: "11", type: "number" },
                                domProps: { value: _vm.csaData.p95Values[2] },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateCharttInRealTime()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.csaData.p95Values,
                                      2,
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _c("input", {
                                staticClass: "extra-small-input",
                                attrs: { readonly: "" },
                                domProps: { value: _vm.$t("na") },
                              }),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _c("input", {
                                staticClass: "extra-small-input",
                                attrs: { readonly: "" },
                                domProps: { value: _vm.$t("na") },
                              }),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "flex-row" }, [
                  _c(
                    "div",
                    {
                      class: {
                        "flex-col": true,
                        "flex-1": true,
                        border: _vm.isInEditMode,
                      },
                    },
                    [
                      _vm.csaData.isCo2GraphRequired
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex-row chart-title chart-title-co2",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("absoluteCo2Emissions")) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.csaData.isCo2GraphRequired
                        ? _c("div", { staticClass: "flex-row" }, [
                            _c("div", {
                              staticClass: "co2-chart",
                              attrs: { id: _vm.co2ChartId },
                            }),
                          ])
                        : _vm._e(),
                      _vm.isInEditMode && _vm.csaData.isCo2GraphRequired
                        ? _c("div", { staticClass: "flex-row grey-bg" }, [
                            _c("div", {
                              staticClass:
                                "flex-col flex-1 flex-justify-center",
                            }),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _vm._v(_vm._s(_vm.csaData.yearLabels[0])),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _vm._v(_vm._s(_vm.csaData.yearLabels[1])),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _vm._v(_vm._s(_vm.csaData.yearLabels[2])),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _vm._v(_vm._s(_vm.csaData.yearLabels[3])),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1 mr-1" }, [
                              _vm._v(_vm._s(_vm.csaData.yearLabels[4])),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.isInEditMode && _vm.csaData.isCo2GraphRequired
                        ? _c("div", { staticClass: "flex-row grey-bg" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex-col flex-1 flex-justify-center",
                              },
                              [_vm._v("CO2")]
                            ),
                            _c("div", { staticClass: "flex-col flex-1" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.csaData.absoluteCo2Values[0],
                                    expression: "csaData.absoluteCo2Values[0]",
                                    modifiers: { number: true },
                                  },
                                ],
                                staticClass: "extra-small-input",
                                attrs: { maxlength: "11", type: "number" },
                                domProps: {
                                  value: _vm.csaData.absoluteCo2Values[0],
                                },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateCharttInRealTime()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.csaData.absoluteCo2Values,
                                      0,
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.csaData.absoluteCo2Values[1],
                                    expression: "csaData.absoluteCo2Values[1]",
                                    modifiers: { number: true },
                                  },
                                ],
                                staticClass: "extra-small-input",
                                attrs: { maxlength: "11", type: "number" },
                                domProps: {
                                  value: _vm.csaData.absoluteCo2Values[1],
                                },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateCharttInRealTime()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.csaData.absoluteCo2Values,
                                      1,
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.csaData.absoluteCo2Values[2],
                                    expression: "csaData.absoluteCo2Values[2]",
                                    modifiers: { number: true },
                                  },
                                ],
                                staticClass: "extra-small-input",
                                attrs: { maxlength: "11", type: "number" },
                                domProps: {
                                  value: _vm.csaData.absoluteCo2Values[2],
                                },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateCharttInRealTime()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.csaData.absoluteCo2Values,
                                      2,
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.csaData.absoluteCo2Values[3],
                                    expression: "csaData.absoluteCo2Values[3]",
                                    modifiers: { number: true },
                                  },
                                ],
                                staticClass: "extra-small-input",
                                attrs: { maxlength: "11", type: "number" },
                                domProps: {
                                  value: _vm.csaData.absoluteCo2Values[3],
                                },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateCharttInRealTime()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.csaData.absoluteCo2Values,
                                      3,
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.csaData.absoluteCo2Values[4],
                                    expression: "csaData.absoluteCo2Values[4]",
                                    modifiers: { number: true },
                                  },
                                ],
                                staticClass: "extra-small-input",
                                attrs: { maxlength: "11", type: "number" },
                                domProps: {
                                  value: _vm.csaData.absoluteCo2Values[4],
                                },
                                on: {
                                  keyup: function ($event) {
                                    return _vm.updateCharttInRealTime()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.csaData.absoluteCo2Values,
                                      4,
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }